import request from '@/config/axios'
// 获取当前登录账号权限
export const refreshToken = () => {
  return request.get({
    baseUrl:'m2i',
    url: 'auth/refreshtoken'
  })
}

// 获取当前登录账号权限
export const getAccountMe = () => {
  return request.get({
    baseUrl:'m2i',
    url: `auth/user/myself`
  })
}

// 获取当前登录账号的org信息
export const getOrgMe = () => {
  return request.get({
    url: `auth/user/orgs`,
    baseUrl:'m2i'  
  })
}